var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"straight-title":_vm.additionalModuleName,"inputs":_vm.inputs,"moduleEnabler":_vm.moduleEnabler,"is-form-fetched":_vm.isFormFetched,"is-custom-saving":_vm.loading || Boolean(_vm.currentTaskId)},on:{"setPayloadValue":_vm.setPayload,"save":_vm.onSave}})
}
var staticRenderFns = []

export { render, staticRenderFns }